var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMicOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.924c1.47 0 2.481-1.108 2.481-2.68v-4.3c0-1.579-1.011-2.68-2.481-2.68-1.477 0-2.488 1.101-2.488 2.68v4.3c0 1.572 1.011 2.68 2.488 2.68zm0-1.019c-.875 0-1.456-.65-1.456-1.66v-4.3c0-1.012.581-1.662 1.456-1.662s1.45.65 1.45 1.661v4.3c0 1.012-.575 1.661-1.45 1.661zm-3.056 5.989h6.105c.287 0 .52-.226.52-.513a.52.52 0 00-.52-.52h-2.536V14.27c2.611-.22 4.375-2.092 4.375-4.779V8.103a.508.508 0 00-.513-.513.513.513 0 00-.52.513v1.346c0 2.331-1.517 3.876-3.855 3.876-2.345 0-3.862-1.545-3.862-3.876V8.103a.51.51 0 00-.52-.513.508.508 0 00-.513.513V9.49c0 2.687 1.771 4.56 4.375 4.779v1.592H6.944a.52.52 0 00-.52.52c0 .287.233.513.52.513z",
    fill: "currentColor"
  })));
}

export default __webpack_public_path__ + "static/media/mic-on.5bf689ff.svg";
export { SvgMicOn as ReactComponent };